import React from "react";

/**
 * TCPA-compliant SMS consent disclosure.
 * Renders wherever we ask for a phone number, immediately before or below the submit button.
 */
export default function SmsConsent({ className = "" }) {
  return (
    <p
      data-testid="sms-consent"
      className={`text-[11px] leading-relaxed text-forest/50 ${className}`}
    >
      By providing your number, you consent to receive SMS messages from Advanced Life Policies.
      Message frequency varies. Msg &amp; data rates may apply.
      Reply <span className="font-semibold text-forest/70">STOP</span> to opt out or{" "}
      <span className="font-semibold text-forest/70">HELP</span> for help.
      Consent is not a condition of purchase.
    </p>
  );
}
